import { render } from "./MobileMenu.vue?vue&type=template&id=4839838e&scoped=true"
import script from "./MobileMenu.vue?vue&type=script&lang=js"
export * from "./MobileMenu.vue?vue&type=script&lang=js"

import "./MobileMenu.vue?vue&type=style&index=0&id=4839838e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4839838e"]])

export default __exports__